// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4f9a5ece","239":"c2192297","732":"b5ee9efc"}[chunkId] + ".chunk.js";
};